<template>
    <div v-if="items.length > limit && !showMore">
        <span> {{ reducedItems + "..." }} </span>
        <span
            class="show-more"
            @click="showMore=true"
        > show more</span>
    </div>
    <div v-else-if="showMore">
        <span> {{ formattedItems }}</span>
        <span
            class="show-more"
            @click="showMore=false"
        > show less</span>
    </div>
    <div v-else>
        <span> {{ formattedItems }} </span>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
    items: {
        type: Array,
        default: () => []
    },
    limit: {
        type: Number,
        default: 3
    },
    separator: {
        type: String,
        default: ', '
    }
})

const reducedItems = computed(() => props.items.slice(0, 3).join(props.separator))
const formattedItems = computed(() => props.items.join(props.separator))
const showMore = ref(false)

</script>

<style scoped>
    .show-more {
        color: blue;
        cursor: pointer
    }
</style>
